import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Route, Switch, Redirect, useHistory } from 'react-router-dom';
import Login from '../areas/controle-acesso/usuario/pages/Login';
import RecuperacaoSenha from '../areas/controle-acesso/usuario/pages/RecuperacaoSenha';
import NovaSenha from '../areas/controle-acesso/usuario/pages/NovaSenha';
import { getAutenticado, logout, getUsuario } from './Configuracoes'
import { ACOES } from './Enums'
import { get } from './AcessoApi'
import NaoEncontrado from '../areas/controle-acesso/util/pages/NaoEncontrado'
import Dashboard from '../areas/shared/Dashboard'
import Home from '../areas/shared/Home'

import SemPermissao from '../areas/shared/SemPermissao'
import SemAcesso from '../areas/shared/SemAcesso'
import ListagemPadrao from '../areas/shared/ListagemPadrao'
import ListagemAlternativa from '../areas/shared/ListagemAlternativa'
import moment from "moment"
import ls from 'local-storage'

import CadastroUsuario from '../areas/controle-acesso/usuario/pages/Cadastro'
import ConsultaUsuario from '../areas/controle-acesso/usuario/pages/Consulta'
import AlteracaoSenha from '../areas/controle-acesso/usuario/pages/AlteracaoSenha'
import CadastroExterno from '../areas/controle-acesso/usuario/pages/CadastroExterno'

import ConsultaModulo from '../areas/controle-acesso/modulo/pages/Consulta'
import CadastroModulo from '../areas/controle-acesso/modulo/pages/Cadastro'

import ConsultaGrupo from '../areas/controle-acesso/grupo/pages/Consulta'
import CadastroGrupo from '../areas/controle-acesso/grupo/pages/Cadastro'
import VisualizacaoGrupo from '../areas/controle-acesso/grupo/pages/Visualizacao'

import ConsultaAuditoria from '../areas/controle-acesso/auditoria/pages/Consulta'
import ConsultaAuditoriaApp from '../areas/controle-acesso/auditoria-app/pages/Consulta'

import ConsultaUsuarioApp from '../areas/controle-acesso/usuario-app/pages/Consulta'
import CadastroUsuarioApp from '../areas/controle-acesso/usuario-app/pages/Cadastro'
import VisualizacaoUsuarioApp from '../areas/controle-acesso/usuario-app/pages/Visualizacao'

import ConsultaProduto from '../areas/estoque/produto/pages/Consulta'
import CadastroProduto from '../areas/estoque/produto/pages/Cadastro'
import CadastroProdutoEntrada from '../areas/estoque/produto-entrada-saida/pages/Cadastro'
import VisualizacaoProdutoEntradaSaida from '../areas/estoque/produto-entrada-saida/pages/Visualizacao'
import ConsultaProdutoEntradaSaida from '../areas/estoque/produto-entrada-saida/pages/Consulta'
import VisualizacaoProduto from '../areas/estoque/produto/pages/Visualizacao'
import RelatorioProduto from '../areas/relatorios/produtos/Relatorio'
import RelatorioDevolucao from '../areas/relatorios/devolucao/Relatorio'

import ConsultaLote from '../areas/devolucao/lote/pages/Consulta'
import CadastroLote from '../areas/devolucao/lote/pages/Cadastro'
import VisualizacaoLote from '../areas/devolucao/lote/pages/Visualizacao'

import CadastroSaidaProduto from '../areas/estoque/produto-entrada-saida/pages/Saida'

import ConsultaCbos from '../areas/parametros/cbos/pages/Consulta'
import Cadastro from '../areas/parametros/cbos/pages/Cadastro'
import VisualizacaoCbos from '../areas/parametros/cbos/pages/Visualizacao'

import VisualizacaoUsuario from '../areas/controle-acesso/usuario/pages/Visualizacao'

import Layout from './Layout'

const PrivateRoute = (propsG) => {
    const { component: Component, fazerAuditoria, configState, ...rest } = propsG
    const [temPermissao, setTemPermissao] = useState(false)
    const [validou, setValidou] = useState(false)
    const [menuAberto, setMenuAberto] = useState(true)

    const user = getUsuario()

    const removerDataConsultaAgenda = (propsG) => {
        if (propsG.modulo != 38) {
            // ls.remove('ultima_data_consulta_agenda')
        }
    }

    const history = useHistory();
    useEffect(() => {


        if (user) {
            removerDataConsultaAgenda(propsG);
            //permitido
            const objPermissao = {
                usuario_id: (user && user.id) || 0,
                modulo_id: propsG.modulo,
                acao_id: propsG.acao
            }

            if (propsG.modulo === undefined || propsG.modulo === 4) {
                setValidou(true)
                setTemPermissao(true)
            }
            else {
                get('/controleAcesso/permissao', objPermissao).then(val => {
                    if (val.length)
                        setTemPermissao(true);
                    else
                        setTemPermissao(false);

                    setValidou(true)
                }).catch(e => {
                    setTemPermissao(false);
                    setValidou(true)
                })
            }

            if (!propsG.path.includes('logout') || !propsG.path.includes('login'))
                ls.set('ultimo_hora_login', moment())

        }
    }, [propsG.path])

    let redirecinarParaHome = propsG.path.includes('dashboard') && ls.get('permissaoDashboard') === false;
    if (redirecinarParaHome) {
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        return (<Redirect to={{ pathname: '/home', state: { from: propsG.location, ...configState } }} />)
    }

    if (!user)
        return (<Redirect to={{ pathname: '/login', state: { from: propsG.location, ...configState } }} />)
    if (validou == true)
        return (<Layout setMenuAberto={setMenuAberto} temPermissao={propsG.modulo == 4 ? true : temPermissao}><Route {...rest} render={props =>
            getAutenticado() ? (<Component menuAberto={menuAberto}  {...props} configState={configState} modulo={propsG.modulo} />) : (<Redirect to={{ pathname: '/login', state: { from: props.location } }} />)
        } /></Layout>)
    else
        return <></>
}
const reload = () => {
    if (window.localStorage) {
        if (!localStorage.getItem('firstLoad')) {
            localStorage['firstLoad'] = true;
            window.location.reload();
        }
        else
            localStorage.removeItem('firstLoad');
    }
}

const LoginRoute = ({ component: Component, realizarLogout, ...rest }) => {

    if (realizarLogout) {
        logout()
        reload()
    }

    return (<Route {...rest} render={props =>
        getAutenticado() ? (<Redirect to={{ pathname: ls.get('permissaoDashboard') === false ? '/home' : '/dashboard', state: { from: props.location } }} />) : (<Component {...props} />)
    } />)
}

const Routes = () => (
    <BrowserRouter>
        <Switch>
            {/* CONTROLE ACESSO */}
            <PrivateRoute modulo={2} acao={ACOES.INSERIR} path='/controleAcesso/grupo/cadastro' active='/controleAcesso/grupo/consulta' component={(props) => <CadastroGrupo {...props} />} />
            <PrivateRoute modulo={2} acao={ACOES.ALTERAR} path='/controleAcesso/grupo/alteracao/:id' active='/controleAcesso/grupo/consulta' component={(props) => <CadastroGrupo {...props} idSubmenu="" />} />
            <PrivateRoute modulo={2} acao={ACOES.CONSULTAR} path='/controleAcesso/grupo/consulta' component={(props) => <ConsultaGrupo {...props} />} />
            <PrivateRoute modulo={2} acao={ACOES.VISUALIZAR} path='/controleAcesso/grupo/visualizacao/:id' active='/controleAcesso/grupo/consulta' component={(props) => <VisualizacaoGrupo {...props} />} />

            <PrivateRoute modulo={1} acao={ACOES.INSERIR} path='/controleAcesso/usuario/cadastro' active='/controleAcesso/usuario/consulta' component={(props) => <CadastroUsuario {...props} />} />
            <PrivateRoute modulo={1} acao={ACOES.ALTERAR} path='/controleAcesso/usuario/alteracao/:id' active='/controleAcesso/usuario/consulta' component={(props) => <CadastroUsuario {...props} />} />
            <PrivateRoute modulo={1} acao={ACOES.ALTERAR} path='/controleAcesso/usuario/alteracaoSenha' component={(props) => <AlteracaoSenha {...props} />} />
            <PrivateRoute modulo={1} acao={ACOES.CONSULTAR} path='/controleAcesso/usuario/consulta' component={(props) => <ConsultaUsuario {...props} />} />
            <PrivateRoute modulo={1} acao={ACOES.VISUALIZAR} path='/controleAcesso/usuario/visualizacao/:id' active='/controleAcesso/usuario/consulta' component={(props) => <VisualizacaoUsuario {...props} />} />
            <Route path='/controleAcesso/usuarioExterno/cadastro/:id' component={(props) => <CadastroExterno {...props} />} />
            <PrivateRoute modulo={8} acao={ACOES.CONSULTAR} path='/controleAcesso/auditoria/consulta' component={(props) => <ConsultaAuditoria {...props} />} />

            <PrivateRoute modulo={3} acao={ACOES.INSERIR} path='/controleAcesso/modulo/cadastro' active='/controleAcesso/modulo/consulta' component={(props) => <CadastroModulo {...props} />} />
            <PrivateRoute modulo={3} acao={ACOES.ALTERAR} path='/controleAcesso/modulo/alteracao/:id' active='/controleAcesso/modulo/consulta' component={(props) => <CadastroModulo {...props} idSubmenu="" />} />
            <PrivateRoute modulo={3} acao={ACOES.CONSULTAR} path='/controleAcesso/modulo/consulta' component={(props) => <ConsultaModulo {...props} />} />

            <PrivateRoute modulo={6} acao={ACOES.INSERIR} path='/estoque/produto/cadastro' active='/estoque/produto/consulta' component={(props) => <CadastroProduto {...props} />} />
            <PrivateRoute modulo={6} acao={ACOES.ALTERAR} path='/estoque/produto/alteracao/:id' active='/estoque/produto/consulta' component={(props) => <CadastroProduto {...props} idSubmenu="" />} />
            <PrivateRoute modulo={6} acao={ACOES.CONSULTAR} path='/estoque/produto/consulta' component={(props) => <ConsultaProduto {...props} />} />
            <PrivateRoute modulo={6} acao={ACOES.VISUALIZAR} path='/estoque/produto/visualizacao/:id' active='/estoque/produto/consulta' component={(props) => <VisualizacaoProduto {...props} />} />
            
            <PrivateRoute modulo={9} acao={ACOES.INSERIR} path='/estoque/produtoentrada/cadastro' active='/estoque/produtoentradasaida/consulta' component={(props) => <CadastroProdutoEntrada {...props} />} />
            <PrivateRoute modulo={9} acao={ACOES.ALTERAR} path='/estoque/produtoentrada/alteracao/:id' active='/estoque/produtoentradasaida/consulta' component={(props) => <CadastroProdutoEntrada {...props} />} />
            <PrivateRoute modulo={11} acao={ACOES.CONSULTAR} path='/estoque/produtoentradasaida/consulta' component={(props) => <ConsultaProdutoEntradaSaida {...props} />} />
            <PrivateRoute modulo={11} acao={ACOES.VISUALIZAR} path='/estoque/produtoentradasaida/visualizacao/:id' active='/estoque/produtoentradasaida/consulta' component={(props) => <VisualizacaoProdutoEntradaSaida {...props} />} />

            <PrivateRoute modulo={10} acao={ACOES.INSERIR} path='/estoque/produtosaida/cadastro' active='/estoque/produtoentradasaida/consulta' component={(props) => <CadastroSaidaProduto {...props} />} />
            <PrivateRoute modulo={10} acao={ACOES.ALTERAR} path='/estoque/produtosaida/alteracao/:id' active='/estoque/produtoentradasaida/consulta' component={(props) => <CadastroSaidaProduto {...props} idSubmenu="" />} />

            <PrivateRoute modulo={13} acao={ACOES.INSERIR} path='/devolucao/lote/cadastro' active='/devolucao/lote/consulta' component={(props) => <CadastroLote {...props} />} />
            <PrivateRoute modulo={13} acao={ACOES.ALTERAR} path='/devolucao/lote/alteracao/:id' active='/devolucao/lote/consulta' component={(props) => <CadastroLote {...props} idSubmenu="" />} />
            <PrivateRoute modulo={13} acao={ACOES.CONSULTAR} path='/devolucao/lote/consulta' component={(props) => <ConsultaLote {...props} />} />
            <PrivateRoute modulo={13} acao={ACOES.VISUALIZAR} path='/devolucao/lote/visualizacao/:id' active='/devolucao/lote/consulta' component={(props) => <VisualizacaoLote {...props} />} />
            
            {/* <PrivateRoute modulo={6} acao={ACOES.CONSULTAR} path='/estoque/produto/consulta' component={(props) => <ConsultaProduto {...props} />} />
            <PrivateRoute modulo={6} acao={ACOES.VISUALIZAR} path='/estoque/produto/visualizacao/:id' active='/estoque/produto/consulta' component={(props) => <VisualizacaoProduto {...props} />} /> */}

            <PrivateRoute modulo={4} path='/semPermissao' component={(props) => <SemPermissao {...props} />} />
            <PrivateRoute modulo={4} path='/semAcesso' component={(props) => <SemAcesso {...props} />} />

            <LoginRoute path='/login' component={(props) => <Login {...props} />} />
            <LoginRoute exact path='/' component={() => <Login />} />
            <LoginRoute path='/logout' component={(props) => <Login {...props} />} realizarLogout={true} />
            <Route path='/recuperarSenha' component={(props) => <RecuperacaoSenha  {...props} />} />
            <Route path='/novasenha/:token' component={(props) => <NovaSenha  {...props} />} />
            
            {/* PARÂMETROS */}
            <PrivateRoute modulo={7} acao={ACOES.INSERIR} path='/parametros/cbos/cadastro' component={(props) => <Cadastro {...props} />} />
            <PrivateRoute modulo={7} acao={ACOES.ALTERAR} path='/parametros/cbos/alteracao/:id' active='/cbos/consulta' component={(props) => <Cadastro {...props} idSubmenu="" />} />
            <PrivateRoute modulo={7} acao={ACOES.CONSULTAR} path='/parametros/cbos/consulta' component={(props) => <ConsultaCbos {...props} />} />
            <PrivateRoute modulo={7} acao={ACOES.VISUALIZAR} path='/parametros/cbos/visualizacao/:id' active='/parametros/cbos/visualizacao' component={(props) => <VisualizacaoCbos {...props} />} />
            
            {/* RELATÓRIOS */}
            <PrivateRoute modulo={7} acao={ACOES.CONSULTAR} path='/relatorios/produtos/relatorio' component={props => <RelatorioProduto {...props} />} />
            <PrivateRoute modulo={7} acao={ACOES.CONSULTAR} path='/relatorios/devolucao/lote' component={props => <RelatorioDevolucao {...props} />} />

            {/* GERAL */}
            <PrivateRoute modulo={4} path='/listagem' component={(props) => <ListagemPadrao {...props} />} />
            <PrivateRoute modulo={4} path='/listagemAlternativa' component={(props) => <ListagemAlternativa {...props} />} />
            <PrivateRoute acao={ACOES.CONSULTAR} path='/dashboard' component={() => <Dashboard />} />
            <PrivateRoute path='/home' component={() => <Home />} />

            <Route path="*"><NaoEncontrado /></Route>
        </Switch>
    </BrowserRouter>
)

export default Routes;
export { reload }

